// FileNameModal.js
import React, { useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

function FileNameModal({ show, onHide, onSubmit, allowTemplate }) {
  const [fileName, setFileName] = useState('');
  // mode: "execute" or "template"
  const [mode, setMode] = useState('execute');

  // Reset state when modal opens
  useEffect(() => {
    if (show) {
      setFileName('');
      setMode('execute');
    }
  }, [show]);

  const handleSubmit = () => {
    const saveAsTemplate = mode === 'template';
    onSubmit(fileName.trim(), saveAsTemplate);
    onHide();
  };

  const title = mode === 'template' ? 'Save as Template' : 'Execute Task';
  const label = mode === 'template' ? 'Template Name' : 'Task Name';
  const placeholder =
    mode === 'template'
      ? 'Enter a template name'
      : 'Enter a task description';

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {allowTemplate && (
          <Form.Group className="mb-3">
            <Form.Label>Action</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                id="execute-now"
                label="Execute Now"
                name="fileAction"
                value="execute"
                checked={mode === 'execute'}
                onChange={() => setMode('execute')}
              />
              <Form.Check
                inline
                type="radio"
                id="save-template"
                label="Save as Template"
                name="fileAction"
                value="template"
                checked={mode === 'template'}
                onChange={() => setMode('template')}
              />
            </div>
          </Form.Group>
        )}

        <Form.Group>
          <Form.Label>{label}</Form.Label>
          <Form.Control
            type="text"
            value={fileName}
            onChange={e => setFileName(e.target.value)}
            placeholder={placeholder}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!fileName.trim()}
        >
          {mode === 'template' ? 'Save Template' : 'Execute Task'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FileNameModal;
